"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// Libs SearchControl
var react_1 = require("react");
require("./styles.css");
var Icon_1 = __importDefault(require("@component/Icon"));
function SearchControl(_a) {
    var searchTerm = _a.searchTerm, placeholder = _a.placeholder, defaultValue = _a.defaultValue, onKeyPress = _a.onKeyPress;
    var inputElt = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(searchTerm), value = _b[0], setValue = _b[1];
    var handleTrack = function () {
        if ((value === null || value === void 0 ? void 0 : value.length) !== 0) {
            // Do something with value
            onKeyPress(value);
        }
        else {
            onKeyPress("");
        }
    };
    var handleKeyPress = function (e) {
        if (e.key === "Enter") {
            handleTrack();
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "search_control_wrapper" }, { children: [(0, jsx_runtime_1.jsx)("input", { ref: inputElt, className: "search_control_input", type: "search", value: value, placeholder: placeholder, onChange: function (e) { return setValue(e.target.value); }, onKeyPress: handleKeyPress }), value && ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: function (e) {
                    setValue("");
                    onKeyPress("");
                } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: "circleXMark", color: "#BEC4C9", size: "md" }) })))] })));
}
exports.default = SearchControl;
//# sourceMappingURL=index.js.map